import { Flex, Spinner } from '@chakra-ui/react'
import { useNavigate } from 'react-router'
import { useAgendas } from '@/hooks/agendas/useAgendas'
import EmptyAgendas from '@/components/EmptyAgendas'
import BigCalendar from './components/BigCalendar'

const CalendarPage = () => {
  const navigate = useNavigate()
  const { data: agendas, isLoading } = useAgendas()

  if (isLoading)
    return (
      <Flex flex="1" align="center" justify="center">
        <Spinner size="lg" color="primary.500" />
      </Flex>
    )

  if (!agendas?.length)
    return (
      <Flex flex="1" align="center" justify="center">
        <EmptyAgendas onButtonClick={() => navigate('/painel/agendas?de_calendario=criar_agenda')} />
      </Flex>
    )

  return <BigCalendar />
}

export default CalendarPage
